module.exports = __webpack_public_path__ + "img/SYMBOL.836390b0.svg";